import React from "react";
import IconButton from "@mui/material/IconButton";
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import CloseIcon from "@mui/icons-material/Close";
import "./EnterpriseAnnouncementBanner.scss";

const SEVERITY_ICON = {
  info: CampaignOutlinedIcon,
  warning: WarningAmberOutlinedIcon,
};

/**
 * Pure presentational bar. Used by the live banner and the settings
 * preview so the two cannot drift.
 */
const BannerContent = ({
  message,
  severity = "info",
  onClose,
  className = "",
}) => {
  const text = String(message || "").trim();
  if (!text) return null;
  const Icon = SEVERITY_ICON[severity] || SEVERITY_ICON.info;

  return (
    <div
      className={`riverr-announcement-bar riverr-announcement-bar--${severity} ${className}`.trim()}
      role="status"
    >
      <Icon
        className="riverr-announcement-bar__icon"
        fontSize="small"
        aria-hidden="true"
      />
      <span className="riverr-announcement-bar__message">{text}</span>
      {onClose ? (
        <IconButton
          size="small"
          onClick={onClose}
          aria-label="Dismiss announcement"
          className="riverr-announcement-bar__close"
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      ) : null}
    </div>
  );
};

export default BannerContent;
